import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import React, { SetStateAction, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { Role } from "./RoleModal";

type AddRoleModalProps = {
  show: boolean;
  onHide: () => void;
  setRoles: React.Dispatch<React.SetStateAction<Role[]>>;
};

const AddRoleModal: React.FC<AddRoleModalProps> = ({
  show,
  onHide,
  setRoles,
}) => {
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { postApi, getApi } = useGeneralApiCall();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    if (!name || !description) {
      setError("Both name and description are required.");
      return;
    }

    setIsLoading(true);
    postApi("/api/auth/v1/roles/", { name, description })
      .then(() => {
        getApi<SetStateAction<Role[]>>("/api/auth/v1/roles").then((res) => {
          setRoles(res.data);
        });
      })
      .then(() => {
        setName("");
        setDescription("");
        onHide();
      })
      .catch((err) => {
        setError(err.message || "An error occurred while adding the role.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static"
      keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add New Role</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Role Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter role name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Role Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter role description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Form.Group>
          <Button type="submit" variant="primary" disabled={isLoading}>
            {isLoading ? "Saving..." : "Save Role"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddRoleModal;
